import { useGetMessagesQuery } from "../messageApiSlice"
import AdminMessage from "./AdminMessage"
import useAuth from "../../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
const AdminMessages = () => {
    const {groupId} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: messages,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetMessagesQuery('messagesList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })

    const [active,setActive] = useState(true)
    const [q,setQ] = useState('')


    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess ) { 
        if(!messages.ids?.length) return <h3 style={{paddingTop:"20px"}}>אין הודעות להצגה</h3>
        let filteredIds = []
        if((groupId!=='0')|| active ||  q!==''){
            filteredIds=[...messages.ids].filter(messageId =>{
                const message =  messages.entities[messageId]
             return ((groupId==='0' || message.group?._id === groupId ) &&
                    (!active || ( message.active &&  Date.parse(message.toDate) - Date.parse(new Date())>0 )) &&
                    (q==='' ||((message.title.toLowerCase().indexOf(q.toLowerCase()) >-1)||(message.body?.toLowerCase().indexOf(q.toLowerCase()) >-1) )))

            })
        }else
            {
                filteredIds = [...messages.ids]
            }
        content = (
            <>
 <div className="filter-form">
        <div className="filter-form-item">
        <label className="form__label form__checkbox-container" htmlFor="active">
                   הודעות פעילות:
                    <input
                        className="form__checkbox"
                        id="active"
                        name="active"
                        type="checkbox"
                        checked={active}
                        onChange={(e)=>setActive(prev => !prev)}
                    />
                    </label>
                    </div>
                    <div className="filter-form-item">

                    
             

        </div>
        <div className="filter-form-item">
            <input className="form__input" onChange={(e)=>setQ(e.target.value)} />
            </div>
    </div>

            {filteredIds.map(id => <AdminMessage key={id} message={messages.entities[id]} />)}
            </>
        )
    }

    return content
}
export default AdminMessages